import React from 'react';
import { Fieldset } from 'components';
import { SingleField } from 'components/ModalInfo.Fields';
import { ProductTimedValueParams } from 'store/products';
import { format } from 'date-fns';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const ProductSegmentInfo = ({
  value,
}: {
  value: ProductTimedValueParams;

  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Fieldset gridColumn='span 3'>
      <SingleField
        header={t('product.startDate', 'Data startu')}
        value={format(value.startDate, 'dd.MM.yyyy')}
        gridColumn={{ base: 'span 6', md: 'span 6' }}
        isDate
      />
      {value.endDate ? (
        <SingleField
          header={t('product.endDate', 'Data zakończenia')}
          value={format(value.endDate, 'dd.MM.yyyy')}
          gridColumn={{ base: 'span 6', md: 'span 6' }}
          isDate
        />
      ) : (
        <Box gridColumn={{ base: 'span 6', md: 'span 6' }} />
      )}
      <SingleField
        header={t('product.impressions', 'Odsłony')}
        value={value.impressions}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
      <SingleField
        header={t('product.clicks', 'Kliknięcia')}
        value={value.clicks}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
      <SingleField
        header={t('product.ctr', 'CTR')}
        value={`${value.ctr}%`}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
      <SingleField
        header={t('product.uniqueUsers', 'Zasięg (UU)')}
        value={value.uniqueUsers}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
      <SingleField
        header={t('product.viewability', 'Viewability')}
        value={value.viewability}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
      <SingleField
        header={t('product.price', 'Stawka')}
        value={`${value.price} ${t('currency.pln.short', 'zł')}`}
        gridColumn={{ base: 'span 4', md: 'span 4' }}
      />
    </Fieldset>
  );
};

ProductSegmentInfo.displayName = 'Product.segmentInfo';

export { ProductSegmentInfo };
